<template>
  <div class="login">
    <img class="backgroundImg" src="./img/bj.png" alt="">
    <div class="log-in">
      <img class="log-inImg" src="./img/logo.png" alt="">
      <!-- <img class="erweima" src="./img/er.png" alt=""> -->
      <div>用户名登陆</div>
      <div class="margin">
        <Input @on-keydown="toindex2" clearable class="login-input" autoComplete="new=pass" type="text" placeholder="请输入手机号" :maxlength="11" v-model.trim="username">
        </Input>
        <img style="z-index:99;position:absolute;width:25px;height:25px;top:7px;left:7px;" src="./img/name.png" alt="">
      </div>
      <div class="margin">
        <Input clearable autoComplete="new=pass" @click.native="aaa" type="password" :readonly="readonly" class="login-input" placeholder="请输入密码" v-model.trim="password" @on-enter="toindex">
        </Input>
        <img style="z-index:99;position:absolute;width:25px;height:25px;top:7px;left:7px;" src="./img/password.png" alt="">
      </div>
      <div class="tishi" v-show="ishowtitle">
        {{title}}
      </div>
      <div class="delet-password">
        <span class="delet-password-span" @click="passwordShow">忘记密码?</span>
      </div>
      <div>
        <Button type="success" @click="toindex" class="btn" ghost>登录</Button>
      </div>

    </div>
    <!-- 忘记密码的弹框 -->
    <Modal width="500" footer-hide v-model="passwordisShow">
      <div class="password-cont">
        <ul class="jindu">
          <li class="jindu-li">
            <span class="border" :class="{'border-active':passwordisShow==true}">1</span>
            <div class="jindu-lis" :class="{'jindu-lis-active':shenfenActive==true}"></div>
          </li>
          <li class="jindu-li">
            <span class="border" :class="{'border-active':shenfenActive==true}">2</span>
            <div class="jindu-lis" :class="{'jindu-lis-active':mimaActive==true}"></div>
          </li>
          <li class="jindu-li">
            <span class="border" :class="{'border-active':mimaActive==true}">3</span>
          </li>
        </ul>
        <ul class="jindu">
          <li class="jindu-li" :class="{'kong-active':passwordisShow==true}"><span>身份验证</span>
            <div class="kong"></div>
          </li>
          <li class="jindu-li" :class="{'kong-active':shenfenActive==true}"><span>设置密码</span>
            <div class="kongs"></div>
          </li>
          <li class="jindu-li" :class="{'kong-active':mimaActive==true}"><span>完成</span></span>
            <div class="kong3"></div>
          </li>
        </ul>

        <div class="form-cont" v-show="passwordisShow && !shenfenActive">
          <div class="form-left">
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
              <FormItem label="手机号：" prop="phone" class="bumenModal-item">
                <Input @on-blur="jiaoyan" clearable v-model.trim="formValidate.phone" class="input" :maxlength="11" placeholder="请输入手机号" />
              </FormItem>
              <FormItem label="验证码：" prop="yanma" class="bumenModal-item">
                <Input clearable v-model="formValidate.yanma" class="input" placeholder="请输入验证码" />
              </FormItem>
            </Form>

          </div>
          <div class="form-right">
            <Button class="btn fiveSize" type="success" ghost @click="yanzhengma">获取验证码</Button>
            <Button class="btn margin" type="success" ghost @click="yanzhengma()" v-show="!isbtn"><span v-show="btnNum!==0">{{btnNum}}秒后</span>重新获取</Button>
          </div>
        </div>
        <!--  -->
        <div class="form-cont form-conts" v-show="shenfenActive && !mimaActive">
          <Form ref="passworddate" :model="passworddate" :rules="rulepassdate" :label-width="120">
            <FormItem label="新密码：" prop="pass" class="bumenModal-item">
              <Input clearable v-model="passworddate.pass" class="input" @on-blur="hhh" type="password" placeholder="请输入密码" />
            </FormItem>
            <FormItem label="确认新密码：" prop="newpass" class="bumenModal-item">
              <Input clearable v-model="passworddate.newpass" class="input" @on-blur="hhh" type="password" placeholder="请输入密码" />
            </FormItem>
          </Form>
        </div>
        <div class="form-cont form-sucesses" v-show="mimaActive">
          <Icon style="font-size:20px;vertical-align:bottom;" type="md-checkmark-circle" />密码设置成功
        </div>
        <div style="clear:both"></div>
      </div>
      <div class="errorTile" v-show="issure">{{errorTitle}}</div>
      <!--  -->
      <div class="secondBumen-bottom" v-show="passwordisShow && !shenfenActive">
        <Button class="btn" type="success" ghost @click="handleReset1('formValidate')">取消</Button>
        <Button class="btn sure" type="success" ghost @click="handleSubmit1('formValidate')">确定</Button>
      </div>
      <div class="secondBumen-bottom" v-show="shenfenActive && !mimaActive">
        <Button class="btn" type="success" ghost @click="handleReset2('addnameobj')">上一步</Button>
        <Button class="btn sure" type="success" ghost @click="handleSubmit2('passworddate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { login, sendSmsPwdCode, checkSmsPwdCode, resetPassword } from "../components/servers/api"
// import { setTimeout } from 'timers';
export default {
  data () {
    return {
      UUID: '',
      errorTitle: '请输入正确的验证码',//'请将确认新密码与新密码的内容保持一致'
      username: '',
      readonly: true,
      isbtn: true,//控制重新获取显示隐藏
      password: '',
      issure: false,
      haha: {
        one: '',
        two: ''
      },
      ishowtitle: false,
      title: '用户名或密码不正确', //请填写用户名 请填写登录密码
      passwordisShow: false,//忘记密码点击
      shenfenActive: false,//身份验证通过
      mimaActive: false,//设置密码通过
      formValidate: {
        phone: '',//18800001234
        yanma: ''
      },
      passworddate: {
        pass: '',
        newpass: ''
      },
      btnNum: 0,
      btntitle: '秒后重新获取',//获取按钮文字
      rulepassdate: {
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur', Number }
        ],
        newpass: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      ruleValidate: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        yanma: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },//必填校验
    }
  },
  methods: {
    jiaoyan () {//手机号输入离焦事件
      if (this.formValidate.phone.length > 0) {
        let reg = /^\d{11}$/;
        if (this.formValidate.phone.length < 11 || this.formValidate.phone.charAt(0) !== '1' || new RegExp(reg).test(this.formValidate.phone) == false) {
          this.issure = true;
          this.errorTitle = '手机号格式错误';
        } else {
          this.issure = false;
        }

      } else {
        this.issure = false;
      }

    },
    hhh () {
      this.issure = false;
    },
    aaa () {//更改只读状态
      this.readonly = false;
    },
    handleReset1 (name) {//取消
      this.$refs[name].resetFields();
      this.passwordisShow = false;
    },
    yanzhengma (index) {//点击获取验证码
      if (this.btnNum == 0 && this.formValidate.phone !== '') {
        let params = {
          phone: Number(this.formValidate.phone)
        }
        sendSmsPwdCode(params).then(res => {
          if (res.data.code == 1) {
            this.issure = false;
            this.btnNum = 60;
            this.isbtn = false;
            this.UUID = res.data.data.UUID;
            let timer = setInterval(() => {
              this.btnNum--
              if (this.btnNum <= 0) {
                this.btnNum = 0;
                clearInterval(timer)
                timer = null;
                setTimeout(() => {
                  this.isbtn = true;
                }, 1000)
              }
            }, 1000);
          } else {
            this.issure = true;
            this.errorTitle = res.data.msg;
          }
        })
      } else if (this.formValidate.phone == '') {
        this.$refs['formValidate'].resetFields();
        this.errorTitle = '请输入手机号';
        this.issure = true;
      }


    },
    handleSubmit1 (name) {//确定
      this.$refs[name].validate((valid) => {
        if (valid) {
          let params = {
            code: this.formValidate.yanma,
            phone: this.formValidate.phone,
            UUID: this.UUID
          }
          checkSmsPwdCode(params).then(res => {
            if (res.data.code == 1) {
              this.issure = false;
              this.shenfenActive = true;
            } else {
              this.errorTitle = '请输入正确的验证码';
              this.issure = true;
            }
          })
        } else {
          this.issure = false;
        }
      })
    },
    handleReset2 () {
      this.shenfenActive = false;
    },
    handleSubmit2 (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.passworddate.newpass !== this.passworddate.pass) {
            this.errorTitle = '请将确认新密码与新密码的内容保持一致';
            this.issure = true;
          } else {
            this.issure = false;
            let params = {
              phone: this.formValidate.phone,
              password1: this.passworddate.pass,
              password2: this.passworddate.newpass

            }
            resetPassword(params).then(res => {
              if (res.data.code == 1) {
                this.mimaActive = true;
                setTimeout(() => {
                  this.passwordisShow = false;
                }, 2000);
              }
            })
          }
        } else {
          this.issure = false;
        }
      })
    },
    passwordShow () {//点击忘记密码
      this.handleReset1('formValidate');
      this.isbtn = true,//控制重新获取显示隐藏
        this.issure = false,
        this.ishowtitle = false,
        this.shenfenActive = false,//身份验证通过
        this.mimaActive = false,//设置密码通过
        this.passwordisShow = true;
    },
    toindex2 (index) {
      if (index.keyCode == 9) {
        this.aaa()
      } else if (index.keyCode == 13) {
        this.toindex()
      }
    },
    toindex (index) {//点击登录
      if (this.username == '') {
        this.ishowtitle = true;
        this.title = '请填写用户名'
        return
      } else if (this.password == '') {
        this.ishowtitle = true;
        this.title = '请填写登录密码'
        return
      }
      let parms = {
        loginName: this.username,
        password: this.password
      }
      login(parms).then(res => {
        if (res.data.code == 1) {
          this.ishowtitle = false;
          let data = res.data.data;
          sessionStorage.setItem("login", JSON.stringify(data))
          this.$router.push({ name: 'index' })
        } else if(res.data.code == 1003){
           this.title = res.data.msg;
          this.ishowtitle = true;
        }else{
          this.title = '用户名或密码错误!'
          this.ishowtitle = true;
        }
      })


    }
  },
  mounted () {
  },
  created () {
    this.username = '';
    this.password = ''
  }
}
</script>

<style lang="scss" scoped="" type="text/css">
@import "./css/conmmon.scss";
.ivu-input-wrapper[data-v-10d9df09] .ivu-input {
  height: 30px;
}
.ivu-modal /deep/ .ivu-modal-body {
  height: 287px;
}
.password-cont {
  color: #7f7f7f;
  width: 100%;
  margin-top: 25px;
  text-align: center;
  .jindu {
    display: inline-block;
    .jindu-li {
      display: inline-block;
      float: left;
      .border {
        width: 30px;
        height: 30px;
        display: inline-block;
        border: 2px solid #d7d7d7;
        border-radius: 50%;
        text-align: center;
        line-height: 29px;
        color: #d7d7d7;
      }
      .border-active {
        color: #53cac3;
        border-color: #53cac3;
      }
    }
    .jindu-lis {
      display: inline-block;
      width: 130px;
      height: 5px;
      background: #d7d7d7;
      vertical-align: middle;
    }
    .jindu-lis-active {
      background: #53cac3;
    }
    .kong,
    .kongs,
    .kong3 {
      display: inline-block;
      width: 115px;
    }
    .kongs {
      width: 128px;
    }
    .kong3 {
      width: 10px;
    }
    .kong-active {
      color: #53cac3;
    }
  }
  .bumenModal-item {
    margin-bottom: 20px;
  }
}
.errorTile {
  width: 100%;
  text-align: center;
  color: #f59a23;
  position: absolute;
  bottom: 48px;
  left: -65px;
  height: 17px;
}
.form-cont {
  width: 100%;
  margin-top: 15px;
  .form-left {
    width: 330px;
    float: left;
  }
  .form-right {
    float: right;
    text-align: left;
    width: 120px;
    .margin {
      width: 120px;
      margin-top: 27px;
    }
  }
}
.form-conts {
  padding-right: 45px;
}
.form-sucesses {
  color: #53cac3;
}
.ivu-input-prefix i {
  line-height: 40px;
}
.v-transfer-dom /deep/ .ivu-modal {
  top: 180px;
}
.v-transfer-dom /deep/ .ivu-modal-content {
  border: 1px solid #53cac3;
}
.delet-password {
  height: 30px;
  width: 100%;
  text-align: right;
  line-height: 40px;
  .delet-password-span {
    cursor: pointer;
  }
}
.log-in .ivu-input-wrapper /deep/ .ivu-input-icon {
  line-height: 40px !important;
}

.log-in .ivu-input-wrapper /deep/ .ivu-input {
  height: 40px !important;
  line-height: 40px;
  padding-left: 50px;
}
.login {
  font-family: SimHei;
  width: 100%;
  height: 100%;
  font-size: 13px;
  .backgroundImg {
    width: 100%;
    height: 100%;
  }
  .tishi {
    width: 100%;
    height: 15px;
    padding-left: 10px;
    color: #ff9900;
    // position: absolute;
    margin-top: 10px;
  }
  .log-in {
    width: 360px;
    height: 380px;
    position: absolute;
    top: 185px;
    left: 55%;
    padding: 30px 40px;
    margin: 0 auto;
    background: #fff;
    border-radius: 10px;
    text-align: left;
    .log-inImg {
      display: block;
      width: 92px;
      height: 92px;
      // border: 1px solid #53CAC3;
      // border-radius: 50%;
      // margin-left: 80px;
      margin: 0 auto;
    }
    .login-input {
      width: 280px;
      height: 40px;
      line-height: 40px;
    }
    .erweima {
      border-bottom-left-radius: 60px;
      width: 60px;
      height: 60px;
      position: absolute;
      top: 20px;
      right: 20px;
    }
    div {
      // margin-top: 10px;
      // text-align: center;
      vertical-align: initial;
      .btn {
        width: 280px;
        height: 40px;
        margin-top: 10px;
      }
    }
    .margin {
      margin-top: 10px;
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue